export { default } from './KitDetailsPage'
